module.exports = __webpack_public_path__ + "assets/img/202107-3.14fcddc6.png";